const filterObj = [
  { id: 0, text: "경력", data: { 1: "신입", 2: "경력", 4: "경력무관" } },
  {
    id: 3,
    text: "학력",
    data: {
      0: "학력무관",
      3: "고등학교 졸업",
      4: "대학졸업(2,3)년",
      5: "대학졸업(4)년",
      6: "대학원 석사졸업",
      7: "대학원 박사졸업",
    },
  },
  {
    id: 4,
    text: "기업형태",
    data: {
      1: " 대기업",
      2: " 30대그룹사",
      3: "매출1000대기업",
      4: "중견기업",
      5: "강소기업",
      6: "외국계기업",
      7: "벤처기업",
      8: "공공기관/공기업",
      9: "비영리단체/협회재단",
      10: "외국기관/단체",
      11: "주권상장",
      12: "코스닥상장",
      13: "코넥스상장",
      14: "해외상장",
    },
  },
  {
    id: 5,
    text: "고용형태",
    data: {
      1: "정규직",
      2: "계약직",
      3: "인턴",
      4: "파견직",
      5: "도급",
      6: "프리랜서",
      7: "아르바이트",
      8: "연수생/교육생",
      9: "병역특례",
      10: "위촉직/개인사업자",
    },
  },
];

// const filterObj = {
//   경력: { 1: "신입", 2: "경력", 4: "경력무관" },
//   학력: {
//     0: "학력무관",
//     3: "고등학교 졸업",
//     4: "대학졸업(2,3)년",
//     5: "대학졸업(4)년",
//     6: "대학원 석사졸업",
//     7: "대학원 박사졸업",
//   },
//   기업형태: {
//     1: " 대기업",
//     2: " 30대그룹사",
//     3: "매출1000대기업",
//     4: "중견기업",
//     5: "강소기업",
//     6: "외국계기업",
//     7: "벤처기업",
//     8: "공공기관/공기업",
//     9: "비영리단체/협회재단",
//     10: "외국기관/단체",
//     11: "주권상장",
//     12: "코스닥상장",
//     13: "코넥스상장",
//     14: "해외상장",
//   },
//   고용형태: {
//     1: "정규직",
//     2: "계약직",
//     3: "인턴",
//     4: "파견직",
//     5: "도급",
//     6: "프리랜서",
//     7: "아르바이트",
//     8: "연수생/교육생",
//     9: "병역특례",
//     10: "위촉직/개인사업자",
//   },
// };

export default filterObj;
